import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Http, Headers } from '@angular/http';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from '../../../app/providers/common-data.service';
import { Helper_Class } from '../../../app/helper_class';
import { ipaddress } from '../../ipaddress';
import { PharmacyService } from '../pharmacy/pharmacy.service';
import { pharmacy_helper } from '../Pharmcy_Helper';
import { Message_data } from '../../../assets/js/Message_data';
@Component({
  selector: 'app-pharma-product-mst',
  templateUrl: './pharma-product-mst.component.html',
  styleUrls: ['./pharma-product-mst.component.css']
})
export class PharmaProductMstComponent implements OnInit {
  public filteredList = [];
  public productFilterList:any = [];
  uomTypeArray: any = [];
  productID: string = "";
  uomListArray: any;
  public supplierListArray: any = [];
  public categoryTypeArray: any = [];
  public mdeicareTypeArray: any = [];
  public productTypeArray: any = [];
  public filteredprodList:any = [];
  public hsnNO: string = "";
  public productName: string = "";
  public shortName: string = "";
  public genericName: string = "";
  public productNameTxt: string;
  public productTypeID;
  public medicareMedID;
  public categoryCtgID;
  public uomCode;
  public manufacturerMfgID;
  public productType: any = [];
  public medicareType: any = [];
  public categoryType: any = [];
  public manufacturer: any = [];
  public quantity;
  public costPrice;
  public sellingPrice;
  public MRP;
  public prodDiscount;
  public product: any = [];
  public pharmacyID;
  public PharmauserID;
  public productMasterAddArray:any = [];
  public rackList:any=[];
  public binList:any=[];
  public productMasterIndex = 0;
  public productTypeList;
  public page_navigate: boolean;
  public prevPageCount: boolean;
  public nextPageCount: boolean;
  public newFlag: boolean;
  public existFlag: boolean;
  public prodType;
  public currentPage;
  public prodDataCount;
  public mainCount;
  public pageList;
  public pageSize;
  public noOfPages: any
  public userInfo;
  public prodCenteralGST;
  public prodStateGST;
  public suppID;
  public suppName;
  public suppIdData;
  public supplierList: any = [];
  public manufacList:any = [];
  public scheduleType;
  public scheduleList;
  public saveFlag: boolean = true;
  private loc_type;
  public mfg_name:string;
  public supp_name: string;
  public rackid:string;
  public binid:string;
  public min_qty:string;

  constructor(public gservice: CommonDataService, public http: Http, public routes: ActivatedRoute, public router: Router, public toastr: ToastrService, public pharmaservice: PharmacyService) {
    this.page_navigate = true;
    this.mainCount = 1;
    this.pageList = "50";
    this.currentPage = 0;
    this.pageSize = 50;
    this.prodType = "New";
    this.newFlag = false;
    this.existFlag = true;
    this.loc_type="trans";
    this.quantity="";
    this.MRP="";
    this.prodCenteralGST="";
    this.prodStateGST="";
  }

  ngOnInit(): void {
    this.productType = "Select";
    this.medicareType = "Select";
    this.categoryType = "Select";
    this.uomTypeArray = "Select";
    this.manufacturer = "Select";
    this.userInfo = Helper_Class.getInfo();
    this.PharmauserID = this.userInfo.user_id;
    this.pharmacyID = this.userInfo.hospitals[0].hptl_clinic_id;
    this.GetProductdata();
    this.getMedicare();
    this.getCategory();
    //this.getManufacturer();
    this.getUOM();
    this.getProductCount();
    this.retrieveProduct();
    //this.getSuppliers();
    this.getSchedule();
    this.getRacks();

    if (pharmacy_helper.getManufacturer() == true || pharmacy_helper.getSupplier() == true) {
      if (pharmacy_helper.getProductMst() != undefined) {
        var productMst = pharmacy_helper.getProductMst();
        this.hsnNO = productMst.hsn_no;
        this.productName = productMst.name;
        this.shortName = productMst.short_name;
        this.genericName = productMst.generic_name;
        this.productTypeID = productMst.product_type_id;
        this.medicareMedID = productMst.medicare_id;
        this.categoryCtgID = productMst.category_type_id;
        this.uomCode = productMst.uom_code;
        this.suppID = productMst.supp_id;
        this.manufacturerMfgID = productMst.mfg_id;
        this.quantity = productMst.per_unit;
        this.costPrice = productMst.cost_price;
        this.sellingPrice = productMst.sales_price;
        this.MRP = productMst.MRP;
        this.prodCenteralGST = productMst.prod_cgst;
        this.prodStateGST = productMst.prod_sgst;
        pharmacy_helper.setProductMst(undefined);
        if (pharmacy_helper.getManufacturer() == true) {
          pharmacy_helper.setManufacturer(undefined);
        } else {
          pharmacy_helper.setSupplier(undefined);
        }
      }
    }
  }

  productTypeSelect() {
    if (this.prodType == "New") {
      this.newFlag = false;
      this.existFlag = true;
      this.hsnNO = "";
      this.productName = "";
      this.shortName = "";
      this.genericName = "";
      this.productType = null;
      this.medicareType = null;
      this.categoryType = null;
      this.uomTypeArray = null;
      this.manufacturer = null;
      this.quantity = "";
      this.costPrice = "";
      this.sellingPrice = "";
      this.MRP = "";
      this.prodCenteralGST = "";
      this.prodStateGST = "";
      this.prodDiscount = "";
    } else {
      this.newFlag = true;
      this.existFlag = false;
    }
  }

  getRacks(){
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/grbd',
      JSON.stringify({
        pharma_id: this.pharmacyID,
      }),
      { headers: headers })
      .subscribe(
        response => {
          var obj = JSON.parse(response["_body"]);
          this.rackList = obj.racks;
        })
  }

  getBins(){
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/gbbr',
      JSON.stringify({
        pharma_id: this.pharmacyID,
        rackid:this.rackid,
      }),
      { headers: headers })
      .subscribe(
        response => {
          var obj = JSON.parse(response["_body"]);
          this.binList = obj.bins;
        })

  }

  getProductCount() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/gcount',
      JSON.stringify({
        pharma_id: this.pharmacyID,
      }),
      { headers: headers })
      .subscribe(
        response => {
          var obj = JSON.parse(response["_body"]);
          this.page_navigate = obj.product_count > 50 ? false : true;
          this.prodDataCount = obj.product_count;
        },
        error => { });
  }

  pagelistChange() {
    this.pageSize = this.pageList;
    this.currentPage = 1;
    this.getProductCount();
    if (this.pageList == "50") {
      if (this.prodDataCount > 50) {
        this.page_navigate = false;
        this.nextPageCount = false;
        this.prevPageCount = false;
      } else {
        this.page_navigate = true;
        this.nextPageCount = true;
        this.prevPageCount = true;
      }

    } else if (this.pageList == "100") {
      if (this.prodDataCount > 100) {
        this.page_navigate = false;
        this.nextPageCount = false;
        this.prevPageCount = false;
      } else {
        this.page_navigate = true;
        this.nextPageCount = true;
        this.prevPageCount = true;
      }

    } else if (this.pageList == "200") {
      if (this.prodDataCount > 200) {
        this.page_navigate = false;
        this.nextPageCount = false;
        this.prevPageCount = false;
      } else {
        this.page_navigate = true;
        this.nextPageCount = true;
        this.prevPageCount = true;
      }
    }
    this.retrieveProduct();
  }

  pageLimitnext() {
    this.currentPage = this.currentPage + 1;
    this.pageSize = this.pageList;
    this.getProductCount();
    this.retrieveProduct();
    this.prevPageCount = false;
    if (this.currentPage == this.noOfPages) {
      this.nextPageCount = true;
    }
  }

  pageLimitPrevious() {
    this.pageSize = this.pageList;
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.getProductCount();
      this.retrieveProduct();
      this.nextPageCount = false;
      if (this.currentPage == "1") {
        this.prevPageCount = true;
      }
    } else {
      this.prevPageCount = true;
    }
  }

  numberOfPages() {
    this.noOfPages = Math.ceil(this.prodDataCount / this.pageList);
    return Math.ceil(this.prodDataCount / this.pageList);
  }

  productFilter() {
    if (this.productNameTxt !== "" && this.productNameTxt.length > 2) {
      this.page_navigate = true;
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/prodByName/',
        JSON.stringify({
          prod_name: this.productNameTxt,
          pharmacy_id: this.pharmacyID,
        }),
        { headers: headers })
        .subscribe(
          response => {
            this.productMasterAddArray = [];
            var obj = JSON.parse(response["_body"]);
            if (obj.products != null) {
              this.productMasterAddArray = [];
              this.pageList = "50";
              this.page_navigate = false;
              this.productMasterIndex = 0;
              for (var i = 0; i < obj.products.length; i++) {
                this.productMasterAddArray.push({
                  Index: this.productMasterIndex,
                  hsn_no: obj.products[i].hsn_no,
                  name: obj.products[i].name,
                  short_name: obj.products[i].short_name,
                  generic_name: obj.products[i].generic_name,
                  medicare_id: obj.products[i].medicare_id,
                  medicare_name: obj.products[i].medicare_name,
                  product_type_id: obj.products[i].product_type_id,
                  product_type_desc: obj.products[i].product_type_desc,
                  category_type_id: obj.products[i].category_type_id,
                  category_name: obj.products[i].category_name,
                  uom_code: obj.products[i].uom_code,
                  uom_desc: obj.products[i].uom_desc,
                  mfg_id: obj.products[i].mfg_id,
                  mfg_name: obj.products[i].mfg_name,
                  product_id: obj.products[i].product_id,
                  pharmacist_id: this.PharmauserID.toString(),
                  per_unit: obj.products[i].per_unit,
                  cost_price: obj.products[i].cost_price,
                  sales_price: obj.products[i].sales_price,
                  MRP: obj.products[i].MRP,
                  prod_cgst: obj.products[i].prod_cgst,
                  prod_sgst: obj.products[i].prod_sgst,
                  prod_disc: obj.products[i].prod_disc,
                  supp_id: obj.products[i].supp_id,
                  supp_name: obj.products[i].supp_name,
                  schedule_type_id: obj.products[i].schedule_type_id,
                  schedule_type_desc: obj.products[i].schedule_type_desc,
                  type:obj.products[i].type,
                  rackid:obj.products[i].rackid,
                  binid:obj.products[i].binid,
                });
                this.productMasterIndex++;
              }
            } else {
              this.toastr.error(Message_data.noPrd);
            }
          },
          error => { }
        )
    } else {
      this.filteredprodList = [];
      this.page_navigate = false;
      this.pageList = "50";
      this.retrieveProduct();
    }
  }

  GetProductdata() {
    this.http.get(ipaddress.getIp + "pharmacontrol/mtypes/").subscribe(
      data => {
        if (data.json().med_details != null) {
          this.productTypeArray = data.json().med_details;
        }
      },
      error => { });
  }

  getMedicare() {
    this.http.get(ipaddress.getIp + "usercontroller/getmedicare/").subscribe(
      data => {
        if (data.json().medicare != null) {
          this.mdeicareTypeArray = data.json().medicare;
          this.medicareMedID = this.mdeicareTypeArray[0].medicare_id;
        }
      },
      error => { });
  }

  getCategory() {
    this.http.get(ipaddress.getIp + "pharmacontrol/gpcat/").subscribe(
      data => {
        if (data.json().product_categories != null) {
          this.categoryTypeArray = data.json().product_categories;
          this.categoryTypeArray.forEach(element => {
          });
        }
      },
      error => { });
  }

  getManufacturer() {
    if(this.mfg_name != undefined && this.mfg_name.length >2){
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp + "pharmacontrol/gman/", JSON.stringify({ pharmacy_id: this.pharmacyID,name:this.mfg_name }), { headers: headers }).subscribe(
        data => {
          if (data.json().manuf_details != null) {
            this.manufacList = data.json().manuf_details;
          }
        },
        error => { });
    }
  }

  manufacturer_change(manufacturer){
    this.manufacturerMfgID = manufacturer.mfg_id;
    this.mfg_name = manufacturer.name;
    this.manufacList=[];
  }

  getUOM() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "pharmacontrol/guom/", JSON.stringify({ pharmacy_id: this.pharmacyID }), { headers: headers }).subscribe(
      data => {
        if (data.json().product_uoms != null) {
          this.uomListArray = data.json().product_uoms;
        }
      },
      error => { });
  }

  saveData() {
    if (this.hsnNO == "" || this.hsnNO == undefined || this.productName == "" || this.productName == undefined ||
      this.productTypeID == undefined || this.medicareMedID == undefined || this.quantity == "" || this.quantity == undefined
      || this.MRP == undefined || this.MRP == "" || this.uomCode == undefined || this.uomCode == "") {
        this.toastr.error(Message_data.mandatory);
        
    } else {
      var cattype;
      var catname;
      if (this.productTypeID != undefined) {
        for (var i = 0; i < this.productTypeArray.length; i++) {
          if (this.productTypeID == this.productTypeArray[i].med_code) {
            this.productType = this.productTypeArray[i];
          }
        }
      }

      if (this.medicareMedID != undefined) {
        for (var i = 0; i < this.mdeicareTypeArray.length; i++) {
          if (this.medicareMedID == this.mdeicareTypeArray[i].medicare_id) {
            this.medicareType = this.mdeicareTypeArray[i];
          }
        }
      }

      if (this.categoryCtgID != undefined) {
        for (var i = 0; i < this.categoryTypeArray.length; i++) {
          if (this.categoryCtgID == this.categoryTypeArray[i].category_id) {
            this.categoryType = this.categoryTypeArray[i];
          }
        }
        if (this.categoryType != undefined) {
          cattype = this.categoryType.category_id;
          catname = this.categoryType.category_name;
        }
      }

      if (this.uomCode != undefined) {
        for (var i = 0; i < this.uomListArray.length; i++) {
          if (this.uomCode == this.uomListArray[i].uom_code) {
            this.uomTypeArray = this.uomListArray[i];
          }
        }
      }

      if (this.manufacturerMfgID != undefined) {
        for (var i = 0; i < this.manufacList.length; i++) {
          if (this.manufacturerMfgID == this.manufacList[i].mfg_id) {
            this.manufacturer = this.manufacList[i];
          }
        }
      }

      this.productID = this.productID != "" ? this.productID : "0";
      var send_data = JSON.stringify({
        hsn_no: this.hsnNO,
        name: this.productName,
        short_name: this.shortName,
        generic_name: this.genericName,
        medicare_id: this.medicareType.medicare_id,
        medicare_name: this.medicareType.medicare_name,
        product_type_id: this.productType.med_code,
        product_type_desc: this.productType.med_name,
        category_type_id: cattype,
        category_name: catname,
        uom_code: this.uomTypeArray.uom_code,
        uom_desc: this.uomTypeArray.uom_desc,
        mfg_id:  this.manufacturer != undefined ? this.manufacturer.mfg_id : undefined,
        mfg_name: this.manufacturer != undefined ? this.manufacturer.name : undefined, 
        product_id: this.productID,
        per_unit: this.quantity,
        cost_price: this.costPrice,
        sales_price: this.sellingPrice,
        MRP: this.MRP,
        prod_cgst: this.prodCenteralGST,
        prod_sgst: this.prodStateGST,
        prod_disc: this.prodDiscount,
        pharmacy_id: this.pharmacyID,
        supp_id: this.suppID,
        schedule_type_id: this.scheduleType,
        type:this.loc_type,
        rackid:this.rackid,
        binid:this.binid,
        min_qty:this.min_qty,
      });
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp + "pharmacontrol/sprodcode/", send_data, { headers: headers }).subscribe(
        data => {
          var obj = data.json();
          if (obj != undefined && obj.key == "1") {
            this.saveFlag = false;
            this.toastr.success(Message_data.prdUpldSuccess);
            this.retrieveProduct();
            this.hsnNO = "";
            this.productName = "";
            this.shortName = "";
            this.genericName = "";
            this.costPrice = undefined;
            this.sellingPrice = undefined;
            this.MRP = "";
            this.quantity = "";
            this.prodCenteralGST = "";
            this.prodStateGST = "";
            this.prodDiscount = undefined;
            this.productTypeID = "";
            this.manufacturerMfgID = undefined;
            this.suppID = undefined;
            this.categoryCtgID = "";
            this.uomCode = "";
            this.medicareType = undefined;
            this.productType = undefined;
            this.categoryType = undefined;
            this.uomTypeArray = undefined;
            this.manufacturer = undefined;
            this.scheduleType = undefined;
            this.prodType = "New";
            this.loc_type="trans";
            this.min_qty="";
          } else {
            this.saveFlag = true;
            this.toastr.error(Message_data.unableToSave);
          }
        },
        error => { this.saveFlag = true; });
    }
  }

  retrieveProduct() {
    var send_data = {
      pharmacist_id: this.PharmauserID,
      pharmacy_id: this.pharmacyID,
      imei: Helper_Class.getIPAddress(),
      limit: this.pageSize,
      start_no: this.currentPage,
    }
    
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "pharmacontrol/gpcbyphar",
      JSON.stringify(send_data),
      { headers: headers }).subscribe(
        data => {
          var obj = data.json();
          if (obj != null && obj.products != null) {
            this.productMasterAddArray = [];
            for (var i = 0; i < obj.products.length; i++) {
              this.productMasterAddArray.push({
                Index: this.productMasterIndex,
                hsn_no: obj.products[i].hsn_no,
                name: obj.products[i].name,
                short_name: obj.products[i].short_name,
                generic_name: obj.products[i].generic_name,
                medicare_id: obj.products[i].medicare_id,
                medicare_name: obj.products[i].medicare_name,
                product_type_id: obj.products[i].product_type_id,
                product_type_desc: obj.products[i].product_type_desc,
                category_type_id: obj.products[i].category_type_id,
                category_name: obj.products[i].category_name,
                uom_code: obj.products[i].uom_code,
                uom_desc: obj.products[i].uom_desc,
                mfg_id: obj.products[i].mfg_id,
                mfg_name: obj.products[i].mfg_name,
                product_id: obj.products[i].product_id,
                pharmacist_id: this.PharmauserID.toString(),
                per_unit: obj.products[i].per_unit,
                cost_price: obj.products[i].cost_price,
                sales_price: obj.products[i].sales_price,
                MRP: obj.products[i].MRP,
                prod_cgst: obj.products[i].prod_cgst,
                prod_sgst: obj.products[i].prod_sgst,
                prod_disc: obj.products[i].prod_disc,
                supp_id: obj.products[i].supp_id,
                supp_name: obj.products[i].supp_name,
                schedule_type_id: obj.products[i].schedule_type_id,
                schedule_type_desc: obj.products[i].schedule_type_desc,
                type:obj.products[i].type,
                rackid:obj.products[i].rackid,
                binid:obj.products[i].binid,
                min_qty:obj.products[i].min_qty,
              });
              this.productMasterIndex++;
            }
          }
        },
        error => { }
      )
  }

  productNameFilter(e) {
    this.filteredList = [];
    this.productName = e.target.value.toString();
    if (this.productName !== "" && this.productName.length > 2) {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/gpbyn',
        JSON.stringify({
          product_name: this.productName
        }),
        { headers: headers })
        .subscribe(
          response => {
            var hospital_txt:any = [];
            var obj = JSON.parse(response["_body"]);
            if (obj.products != null) {
              this.productFilterList = obj.products;
              for (var i = 0; i < this.productFilterList.length; i++) {
                hospital_txt.push(this.productFilterList[i].name);
              }
              this.filteredList = hospital_txt.filter(function (this: any, el) {
                return el.toLowerCase().indexOf(this.product_name.toLowerCase()) > -1;
              }.bind(this));
            }
          },
          error => { }
        )
    } else {
      this.filteredList = [];
    }
  }

  selectItem(data) {
    this.productName = data;
    this.filteredList = [];
    for (var i = 0; i < this.productFilterList.length; i++) {
      if (data == this.productFilterList[i].name) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/gpd',
          JSON.stringify({
            product_id: this.productFilterList[i].product_id
          }),
          { headers: headers })
          .subscribe(
            response => {
              var obj = JSON.parse(response["_body"]);
              if (obj.hsn_no != null) {
                this.hsnNO = obj.hsn_no;
                this.shortName = obj.short_name;
                this.genericName = obj.generic_name;
                this.quantity = obj.per_unit;;
                this.productID = obj.product_id;
                for (var j = 0; j < this.mdeicareTypeArray.length; j++) {
                  if (this.mdeicareTypeArray[j].medicare_id == obj.medicare_id) {
                    this.medicareType = this.mdeicareTypeArray[j];
                    break;
                  }
                }
                for (var j = 0; j < this.productTypeArray.length; j++) {
                  if (this.productTypeArray[j].med_code == obj.product_type_id) {
                    this.productType = this.productTypeArray[j];
                    break;
                  }
                }
                for (var j = 0; j < this.categoryTypeArray.length; j++) {
                  if (this.categoryTypeArray[j].category_id == obj.category_type_id) {
                    this.categoryType = this.categoryTypeArray[j];
                    break;
                  }
                }
                for (var j = 0; j < this.uomListArray.length; j++) {
                  if (this.uomListArray[j].uom_code == obj.uom_code) {
                    this.uomTypeArray = this.uomListArray[j];
                    break;
                  }
                }
                for (var j = 0; j < this.manufacList.length; j++) {
                  if (this.manufacList[j].mfg_id == obj.mfg_id) {
                    this.manufacturer = this.manufacList[j];
                    break;
                  }
                }
              }
            },
            error => {
              this.toastr.error(JSON.stringify(error.json()));
            }
          )
      }
    }
  }

  editProductMaster(data) {
    if (this.productMasterAddArray.length != 0) {
      this.prodType = "Existing";
      for (var i = 0; i < this.productMasterAddArray.length; i++) {
        if (this.productMasterAddArray[i].Index == data) {
          this.productID = this.productMasterAddArray[i].product_id;
          this.hsnNO = this.productMasterAddArray[i].hsn_no;
          this.productName = this.productMasterAddArray[i].name;
          this.shortName = this.productMasterAddArray[i].short_name;
          this.genericName = this.productMasterAddArray[i].generic_name;
          this.suppID = this.productMasterAddArray[i].supp_id;
          this.supp_name = this.productMasterAddArray[i].supp_name;
          this.manufacturerMfgID = this.productMasterAddArray[i].mfg_id;
          this.mfg_name = this.productMasterAddArray[i].mfg_name;
          this.rackid = this.productMasterAddArray[i].rackid;
          this.binid = this.productMasterAddArray[i].binid;
          this.min_qty = this.productMasterAddArray[i].min_qty;
          if(this.binid != undefined){
            this.getBins();
          }

          for (var j = 0; j < this.productTypeArray.length; j++) {
            if (this.productTypeArray[j].med_code == this.productMasterAddArray[i].product_type_id) {
              this.productType = this.productTypeArray[j];
              this.productTypeID = this.productMasterAddArray[i].product_type_id;
            }
          }
          for (var j = 0; j < this.mdeicareTypeArray.length; j++) {
            if (this.mdeicareTypeArray[j].medicare_id == this.productMasterAddArray[i].medicare_id) {
              this.medicareType = this.mdeicareTypeArray[j];
              this.medicareMedID = this.productMasterAddArray[i].medicare_id;
            }
          }
          for (var j = 0; j < this.categoryTypeArray.length; j++) {
            if (this.categoryTypeArray[j].category_id == this.productMasterAddArray[i].category_type_id) {
              this.categoryType = this.categoryTypeArray[j];
              this.categoryCtgID = this.productMasterAddArray[i].category_type_id;
            }
          }
          for (var j = 0; j < this.uomListArray.length; j++) {
            if (this.uomListArray[j].uom_code == this.productMasterAddArray[i].uom_code) {
              this.uomTypeArray = this.uomListArray[j];
              this.uomCode = this.productMasterAddArray[i].uom_code;
            }
          }
          
          if (this.productMasterAddArray[i].schedule_type_id != undefined){
            this.scheduleList = this.productMasterAddArray[i].schedule_type_id;
            this.scheduleType = this.productMasterAddArray[i].schedule_type_id;
          }
          
          this.suppID = this.productMasterAddArray[i].supp_id.toString();
          this.quantity = parseInt(this.productMasterAddArray[i].per_unit);
          if(this.productMasterAddArray[i].cost_price!= undefined){
            this.costPrice = this.productMasterAddArray[i].cost_price;
          }
          if(this.productMasterAddArray[i].sales_price != undefined){
            this.sellingPrice = this.productMasterAddArray[i].sales_price;
          }
          
          this.MRP = this.productMasterAddArray[i].MRP.toString();
          if(this.productMasterAddArray[i].prod_disc != undefined){
            this.prodDiscount = this.productMasterAddArray[i].prod_disc;
          }
          this.prodCenteralGST = this.productMasterAddArray[i].prod_cgst,
          this.prodStateGST = this.productMasterAddArray[i].prod_sgst,
          this.loc_type=this.productMasterAddArray[i].type;
          this.productMasterAddArray.splice(i, 1);
        }
      }
    }
  }

  getSuppliers() {
    if(this.supp_name != undefined && this.supp_name.length >2){
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp + "pharmacontrol/gsup/",
        JSON.stringify({
          pharmacy_id: this.pharmacyID,
          supp_name: this.supp_name

        }), { headers: headers }).subscribe(
          data => {
            this.supplierList = [];
            if (data.json().supplier_details != null && data.json().supplier_details.length != 0) {
              this.supplierList = data.json().supplier_details;
            }
          },
          error => {
            this.toastr.error(Message_data.unableToFetchDocDet);
          }
        )
    }
    
  }

  supplier_change(supplier){
    this.suppID = supplier.supp_id;
    this.supp_name = supplier.name;
    this.supplierList=[];
  }

  getSchedule() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.get(ipaddress.getIp + "pharmacontrol/gsch", { headers: headers }).subscribe(
      data => {
        this.scheduleList = [];
        var obj = data.json();
        if (obj != undefined && obj.schedules.length != 0) {
          this.scheduleList = obj.schedules;
        }
      },
      error => {
        this.toastr.error(Message_data.unableToFetchDocDet);
      }
    )
  }

  createNew(e) {
    var cattype;
    var catname;
    if (this.productTypeID != undefined) {
      for (var i = 0; i < this.productTypeArray.length; i++) {
        if (this.productTypeID == this.productTypeArray[i].med_code) {
          this.productType = this.productTypeArray[i];
        }
      }
    }
    if (this.medicareMedID != undefined) {
      for (var i = 0; i < this.mdeicareTypeArray.length; i++) {
        if (this.medicareMedID == this.mdeicareTypeArray[i].medicare_id) {
          this.medicareType = this.mdeicareTypeArray[i];
        }
      }
    }
    if (this.categoryCtgID != undefined) {
      for (var i = 0; i < this.categoryTypeArray.length; i++) {
        if (this.categoryCtgID == this.categoryTypeArray[i].category_id) {
          this.categoryType = this.categoryTypeArray[i];
        }
      }
      if (this.categoryType != undefined) {
        cattype = this.categoryType.category_id;
        catname = this.categoryType.category_name;
      }
    }
    if (this.uomCode != undefined) {
      for (var i = 0; i < this.uomListArray.length; i++) {
        if (this.uomCode == this.uomListArray[i].uom_code) {
          this.uomTypeArray = this.uomListArray[i];
        }
      }
    }
    if (this.manufacturerMfgID != undefined) {
      for (var i = 0; i < this.manufacList.length; i++) {
        if (this.manufacturerMfgID == this.manufacList[i].mfg_id) {
          this.manufacturer = this.manufacList[i];
        }
      }
    }
    this.productID = this.productID != "" ? this.productID : "0";
    var send_data = {
      hsn_no: this.hsnNO,
      name: this.productName,
      short_name: this.shortName,
      generic_name: this.genericName,
      medicare_id: this.medicareType.medicare_id,
      medicare_name: this.medicareType.medicare_name,
      product_type_id: this.productType.med_code,
      product_type_desc: this.productType.med_name,
      category_type_id: cattype,
      category_name: catname,
      uom_code: this.uomTypeArray.uom_code,
      uom_desc: this.uomTypeArray.uom_desc,
      mfg_id: this.manufacturer.mfg_id,
      mfg_name: this.manufacturer.name,
      product_id: this.productID,
      per_unit: this.quantity,
      cost_price: this.costPrice,
      sales_price: this.sellingPrice,
      MRP: this.MRP,
      prod_cgst: this.prodCenteralGST,
      prod_sgst: this.prodStateGST,
      prod_disc: this.prodDiscount,
      pharmacy_id: this.pharmacyID,
      supp_id: this.suppID,
      min_qty:this.min_qty,
    };
    pharmacy_helper.setProductMst(send_data);
    if (e == 'Supplier') {
      pharmacy_helper.setSupplier(true);
      this.pharmaservice.sendMessage("pharmacysupplier");
    } else {
      pharmacy_helper.setManufacturer(true);
      this.pharmaservice.sendMessage("manufacturer");
    }
  }
}
